import React, { useState, useRef, useEffect } from 'react';
import { Filter } from 'lucide-react';
import './CategoryDropdown.css';

const CategoryDropdown = ({ 
  value, 
  onChange, 
  categories = [], 
  placeholder = "All Categories",
  className = "" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || '');
  const [filteredCategories, setFilteredCategories] = useState(categories);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setInputValue(value || '');
  }, [value]);

  useEffect(() => {
    setFilteredCategories(categories);
  }, [categories]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    
    // Filter categories based on input
    const filtered = categories.filter(category =>
      category.toLowerCase().includes(newValue.toLowerCase())
    );
    setFilteredCategories(filtered);
    
    // Update parent component
    onChange(newValue);
  };

  const handleSelectCategory = (category) => {
    setInputValue(category);
    setFilteredCategories(categories);
    setIsOpen(false);
    onChange(category);
  };

  const handleInputClick = () => {
    setIsOpen(!isOpen);
    setFilteredCategories(categories);
  };

  const handleInputFocus = () => {
    setIsOpen(true);
    setFilteredCategories(categories);
  };

  return (
    <div className={`category-dropdown ${className}`} ref={dropdownRef}>
      <div 
        className={`category-input-container ${isOpen ? 'open' : ''}`}
        onClick={handleInputClick}
      >
        <Filter size={16} className="filter-icon" />
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          placeholder={placeholder}
          className="category-input-field"
        />
        <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </div>
      </div>
      
      {isOpen && (
        <div className="dropdown-menu">
          {filteredCategories.length > 0 ? (
            filteredCategories.map((category, index) => (
              <div
                key={index}
                className={`dropdown-item ${inputValue === category ? 'selected' : ''}`}
                onClick={() => handleSelectCategory(category)}
              >
                {category}
              </div>
            ))
          ) : (
            <div className="dropdown-item no-results">
              No categories found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CategoryDropdown;
